module.exports = __webpack_public_path__ + "static/img/sororas-2.83beb92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/sororas-2.jpg
// module id = FIAe
// module chunks = 1